module.exports = __webpack_public_path__ + "img/prize-03.310b632c.png";